import type { DTO } from '@readcloud/common';
import type { Book, Cloud } from '@readcloud/data';
import type { AxiosResponse } from 'axios';
import React from 'react';
import type {
  CreateCloudOperation,
  DeleteCloudOperation,
  HomeSettings,
  RemoveBookFromCloudOperation,
  UpdateCloudOperation,
} from '../types';

export type ActionsContext = {
  tileClick: (book: Book, cloud: Cloud) => void;
  logout: () => void;
  updateSettings: (settings: Partial<HomeSettings>) => void;
  createCloud: CreateCloudOperation;
  updateCloud: UpdateCloudOperation;
  deleteCloud: DeleteCloudOperation;
  removeBookFromCloud: RemoveBookFromCloudOperation;
  refresh: () => void;
  uploadFile: (request: DTO.UploadFileRequest) => Promise<AxiosResponse>;
  gotoContent: () => void;
};

const context = React.createContext<ActionsContext | null>(null);

export const CloudsAndContentActionsProvider = ({
  children,
  ...ctxValue
}: ActionsContext & { children: React.ReactNode }) => (
  <context.Provider value={ctxValue}>{children}</context.Provider>
);

export function useCloudsAndContentActions() {
  const ctx = React.useContext(context);
  if (!ctx) {
    throw Error('Tried to use clouds and content actions without a provider');
  }
  return ctx;
}
